@if (stores$ | async; as stores) {
  <boels-vertical-aligner class="store-finder-list-map__container -mobile">
    @defer {
      <div class="store-finder-list-map__wrapper">
        @if (stores.stores && stores.stores.length > 0) {
          <div class="store-finder-list-map__list">
            @if (active$ | async; as active) {
              <ng-container
                *ngTemplateOutlet="
                  titleTemplate;
                  context: {
                    stores: stores,
                    isRegion: isRegion,
                    region: region,
                  }
                "
              ></ng-container>
              <ng-container
                *ngTemplateOutlet="
                  storeItemTemplate;
                  context: { stores: stores, active: active }
                "
              ></ng-container>
            }
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="noStoresTemplate"></ng-container>
        }
      </div>
    }
  </boels-vertical-aligner>

  <boels-vertical-aligner
    [innerWidth]="'wide'"
    class="store-finder-list-map__container -desktop"
  >
    <div class="store-finder-list-map__wrapper">
      @if (stores.stores && stores.stores.length > 0) {
        <div class="store-finder-list-map__list">
          @if (active$ | async; as active) {
            <ng-container
              *ngTemplateOutlet="
                titleTemplate;
                context: { stores: stores, isRegion: isRegion, region: region }
              "
            ></ng-container>

            <ng-container
              *ngTemplateOutlet="
                storeItemTemplate;
                context: { stores: stores, active: active }
              "
            ></ng-container>
          }
        </div>

        <div class="store-finder-list-map__map">
          @if (active$ | async; as active) {
            <boels-google-maps
              class=""
              [active]="active"
              [fitBounds]="true"
              [zoomLevel]="12"
              [pointOfServices]="stores.stores"
              (markerClicked)="setActive($event)"
              [mapCenter]="mapCenter"
              [sourceMarkerPosition]="{
                latitude: stores.sourceLatitude,
                longitude: stores.sourceLongitude,
              }"
            ></boels-google-maps>
          }
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="noStoresTemplate"></ng-container>
      }
    </div>
  </boels-vertical-aligner>
} @else {
  <boels-spinner></boels-spinner>
}

<ng-template
  #titleTemplate
  let-stores="stores"
  let-isRegion="isRegion"
  let-region="region"
>
  <div class="store-finder-list-map__list__title-wrapper">
    @if (!isRegion) {
      {{
        'storeFinder.result.storesFound'
          | transloco: { count: stores.stores.length }
      }}
    } @else {
      <h1 class="h4">
        {{ 'storeFinder.result.regionTitle' | transloco: { region: region } }}
      </h1>
    }
  </div>
</ng-template>

<ng-template #storeItemTemplate let-stores="stores" let-active="active">
  @for (store of stores.stores; track store; let i = $index) {
    <boels-store-finder-list-item
      [store]="store"
      [attr.data-qa]="'storeItem'"
      [isActive]="active?.name === store.name"
      (selectedStore)="setActiveAndCenterMap($event)"
      [listNumber]="i + 1"
      [attr.data-dm]="
        {
          data_type: 'branch',
          location_name: store.displayName,
          location_id: store.name,
          index: i + 1,
        } | json
      "
      [isRegion]="isRegion"
    >
    </boels-store-finder-list-item>
  }
</ng-template>

<ng-template #noStoresTemplate>
  <div
    class="store-finder-list-map__no-stores__container"
    [attr.data-qa]="'noStore'"
  >
    <div class="store-finder-list-map__no-stores__inner">
      {{ 'storeFinder.result.noStoresMessage' | transloco }}
    </div>
  </div>
</ng-template>
